import script from "./ColorSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./ColorSelect.vue?vue&type=script&setup=true&lang=js"

import "./ColorSelect.vue?vue&type=style&index=0&id=021974ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-021974ec"]])

export default __exports__